'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.RESET = exports.CLOSE = exports.OPEN = exports.CHANGE_REVIEW_CERTIFICATION = exports.CHANGE_REVIEW_STAGE = exports.CHANGE_REVIEW_BODY = exports.POST_REVIEW = exports.CHANGE_TENTATIVE_RATING = exports.CHANGE_REVIEW_CODE = exports.CHANGE_RATING = exports.VALIDATE_REVIEW_CODE = undefined;

var _doctifyUtils = require('doctify-utils');

var VALIDATE_REVIEW_CODE = exports.VALIDATE_REVIEW_CODE = 'CREATE_REVIEW_MODAL:VALIDATE_REVIEW_CODE';
var CHANGE_RATING = exports.CHANGE_RATING = 'CREATE_REVIEW_MODAL:CHANGE_RATING';
var CHANGE_REVIEW_CODE = exports.CHANGE_REVIEW_CODE = 'CREATE_REVIEW_MODAL:CHANGE_REVIEW_CODE';
var CHANGE_TENTATIVE_RATING = exports.CHANGE_TENTATIVE_RATING = 'CREATE_REVIEW_MODAL:CHANGE_TENTATIVE_RATING';
var POST_REVIEW = exports.POST_REVIEW = 'CREATE_REVIEW_MODAL:POST_REVIEW';
var CHANGE_REVIEW_BODY = exports.CHANGE_REVIEW_BODY = 'CREATE_REVIEW_MODAL:CHANGE_REVIEW_BODY';
var CHANGE_REVIEW_STAGE = exports.CHANGE_REVIEW_STAGE = 'CREATE_REVIEW_MODAL:CHANGE_REVIEW_STAGE';
var CHANGE_REVIEW_CERTIFICATION = exports.CHANGE_REVIEW_CERTIFICATION = 'CREATE_REVIEW_MODAL:CHANGE_REVIEW_CERTIFICATION';
var OPEN = exports.OPEN = 'CREATE_REVIEW_MODAL:OPEN';
var CLOSE = exports.CLOSE = 'CREATE_REVIEW_MODAL:CLOSE';
var RESET = exports.RESET = 'CREATE_REVIEW_MODAL:RESET';

var CreateReviewModalActions = {
	open: function open() {
		return { type: OPEN };
	},
	close: function close() {
		return { type: CLOSE };
	},
	validateReviewCode: function validateReviewCode(code) {
		return (0, _doctifyUtils.createAction)({
			url: 'reviews/codes/' + code,
			method: 'GET',
			actionType: VALIDATE_REVIEW_CODE
		});
	},
	changeRating: function changeRating(rating) {
		return {
			type: CHANGE_RATING,
			rating: rating
		};
	},
	changeTentativeRating: function changeTentativeRating(tentativeRating) {
		return {
			type: CHANGE_TENTATIVE_RATING,
			tentativeRating: tentativeRating
		};
	},
	changeReviewCertification: function changeReviewCertification(value) {
		return {
			type: CHANGE_REVIEW_CERTIFICATION,
			isCertified: value
		};
	},
	changeReviewStage: function changeReviewStage(stage) {
		return {
			type: CHANGE_REVIEW_STAGE,
			stage: stage
		};
	},
	changeReviewBody: function changeReviewBody(body) {
		return {
			type: CHANGE_REVIEW_BODY,
			body: body
		};
	},
	changeReviewCode: function changeReviewCode(code) {
		return {
			type: CHANGE_REVIEW_CODE,
			code: code
		};
	},
	reset: function reset() {
		return {
			type: RESET
		};
	},
	postReview: function postReview(review, profile) {
		return (0, _doctifyUtils.createAction)({
			url: profile.type + 's/' + profile.id + '/reviews',
			data: review,
			method: 'POST',
			actionType: POST_REVIEW
		});
	}
};

exports.default = CreateReviewModalActions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/actions/create-review-modal.js
// module id = 648
// module chunks = 0